module.exports = __webpack_public_path__ + "img/1.5.55cc7c78.png";